import { render, staticRenderFns } from "./big-tree.vue?vue&type=template&id=1a9a4993&"
import script from "./big-tree.js?vue&type=script&lang=js&"
export * from "./big-tree.js?vue&type=script&lang=js&"
import style0 from "./big-tree.less?vue&type=style&index=0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports